/**
 * Category grid — autoplay mudo quando visível (banner com vídeo).
 */
(function () {
  function initSection(section) {
    var videos = section.querySelectorAll('.category-grid__video');
    if (!videos.length) return;

    if (typeof IntersectionObserver === 'undefined') {
      videos.forEach(function (video) {
        video.muted = true;
        video.playsInline = true;
        video.play().catch(function () {});
      });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          var video = entry.target;
          if (!(video instanceof HTMLVideoElement)) return;
          if (entry.isIntersecting) {
            video.muted = true;
            video.playsInline = true;
            video.preload = 'auto';
            video.play().catch(function () {});
          } else {
            video.pause();
          }
        });
      },
      { threshold: 0.35, rootMargin: '0px 0px -5% 0px' }
    );

    videos.forEach(function (video) {
      video.preload = 'none';
      observer.observe(video);
    });
  }

  function boot() {
    document.querySelectorAll('.category-grid[data-has-videos]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
